import { createGlobalStyle } from 'styled-components';

import FrontypeOtf from '../fonts/frontype.otf';
import FrontypeTtf from '../fonts/frontype.ttf';
import SportsCollegeHandwrittenOtf from '../fonts/sports-college-handwritten.otf';
import SportsCollegeHandwrittenTtf from '../fonts/sports-college-handwritten.ttf';
import SportsCollegeHandwrittenWoff from '../fonts/sports-college-handwritten.woff';
import SportsCollegeOtf from '../fonts/sports-college.otf';
import SportsCollegeTtf from '../fonts/sports-college.ttf';
import SportsCollegeWoff from '../fonts/sports-college.woff';

const GlobalStyle = createGlobalStyle`
  :root, html, body {
    color-scheme: only light;
  }

  html {
    forced-color-adjust: none;
    -webkit-text-fill-color: initial;
  }

  @media (prefers-color-scheme: dark) {
    :root, html, body {
      color-scheme: only light;
      background-color: #ffffff !important;
      color: #1C1C1C !important;
    }

    img, svg, video {
      filter: none !important;
    }
  }

  @font-face {
    font-family: 'Sports College Handwritten';
    src: url(${SportsCollegeHandwrittenWoff}) format('woff'),
         url(${SportsCollegeHandwrittenTtf}) format('truetype'),
         url(${SportsCollegeHandwrittenOtf}) format('opentype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Sports College';
    src: url(${SportsCollegeWoff}) format('woff'),
         url(${SportsCollegeTtf}) format('truetype'),
         url(${SportsCollegeOtf}) format('opentype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Frontype';
    src: url(${FrontypeTtf}) format('truetype'),
         url(${FrontypeOtf}) format('opentype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
`;

export default GlobalStyle;
